module.exports = __webpack_public_path__ + "img/h1.a733d49d.jpg";